/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable eqeqeq */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { StudentSidebar } from '../components/StudentSidebar';
import StudentDraggableSidebar from '../components/StudentDraggableSidebar';
import { useDispatch, useSelector } from 'react-redux';
import { setSiteMode, resetSiteMode } from '../Store/settings/siteSettings';
import Modal from '../components/Modal';
import dimond from '../assets/images/greyled-activity.svg';
import { StudentHeader } from '../components/StudentHeader';
import { StudentRightSidebar } from '../components/StudentRightSidebar';
import DeleteModal from '../components/DeleteModal';
import moment from 'moment';
import ActivitySetModal from '../components/AvtivitySetModal';
import { StudentInnerHeader } from '../components/StudentInnerHeader';
import HtmlAsText from '../components/createmode/HtmlAsText';
import MediaComponent from '../components/createmode/MediaComponent';

const currentMonth = moment().month();
const daysInMonth = moment().daysInMonth();

const datesArray = [];
for (let day = 1; day <= daysInMonth; day++) {
  const date = moment().month(currentMonth).date(day);
  datesArray.push(date.date());
}

const StudentBook = () => {
  // const { settings } = useSelector((state) => state.settings);
  const { studentReader } = useSelector((state) => state.ui.studentReader);
  const { book } = useSelector((state) => state.entities.student);
  const { loaders } = useSelector((state) => state.ui);
  const { settings } = useSelector((state) => state.settings.settings);
  const { chapter, topScroll } = studentReader;
  const [activities, setActivities] = useState([]);
  const [scrollToId, setScrollToId] = useState(null);
  const [highlightedSection, setHighlightedSection] = useState([]);
  const [highlightedChapter, setHighlightedChapter] = useState(null);

  const [showCalendar, setShowCalendar] = useState(undefined);
  const [setMousePosition] = useState({ x: 0, y: 0 });
  const [dragging] = useState(false);
  const [creatingActivity] = useState(undefined);
  const [draggedOver] = useState(null);
  const [writingActivity] = useState(false);
  const [reverse] = useState(false);
  const [highlightedIndexes] = useState([]);
  const [isResizing, setIsResizing] = useState(false);
  const [, setClassName] = useState('');
  const [isScrolling, setIsScrolling] = useState(false);
  const [highlightedParagraph, setHighlightedParagraph] = useState(null);
  const [isDraggingActivity, setIsDraggingActivity] = useState(false);
  const [draggedActivity] = useState(null);
  const [spreadActivities, setSpreadActivities] = useState([]);

  const [, setDraggedActivityPosition] = useState({
    top: 0,
    left: 0,
  });

  const [books, setBooks] = useState({
    book: {},
    chapters: [],
    activities: [],
  });
  const [activitySetModal, setActivitySetModal] = useState({
    show: false,
    choice: '',
  });

  const spreadActivitiesSetter = (id) => {
    if (spreadActivities.includes(id)) {
      setSpreadActivities(spreadActivities.filter((e) => e !== id));
    } else {
      setSpreadActivities([...spreadActivities, id]);
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSiteMode('student'));
    return () => {
      dispatch(resetSiteMode());
    };
  }, []);

  useEffect(() => {
    setActivities(book?.activities);
    return () => {};
  }, [book]);

  const scrollerRef = useRef(null);
  let timerId = null;
  let timerId2 = null;

  useEffect(() => {
    if (!creatingActivity) {
      timerId2 = setTimeout(() => {
        setClassName('d-none');
      }, 500); // Delay of 0.5 seconds (500 milliseconds)
    } else {
      setClassName('');
    }
    return () => {
      clearTimeout(timerId2); // Clean up the timeout on component unmount or state change
    };
  }, [creatingActivity]);

  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);
      if (div) {
        setTimeout(() => {
          div.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 200);
        setScrollToId('');
      }
    }
  }, [scrollToId]);

  useEffect(() => {
    if (scrollerRef.current) {
      scrollerRef.current.scrollTop = topScroll;
    }
  }, [scrollerRef.current]);

  const scrollableContent = (scroller) => {
    scrollerRef.current = scroller;
  };

  const scrollToSection = (sec, chap) => {
    setScrollToId(sec);
  };

  const scrollToChapter = (chap, chapSec) => {
    setScrollToId(chap);
  };

  const scrollToParagraph = (chap, sec, par) => {
    setScrollToId(`${chap}.${sec}.${par}`);
  };
  const highlightChapter = (e, value) => {
    if (creatingActivity) return;
    if (highlightedChapter === value) {
      setHighlightedChapter(null);
      setActivities(book.activities);
    } else {
      setHighlightedChapter(value);
      setActivities(
        book.activities.filter(
          (e) =>
            e.chapter._id === value &&
            e.paragraphs.length === 0 &&
            (!Array.isArray(e.sections) || e?.sections?.length === 0)
        )
      );
      // setScrollToId(value);
    }
  };

  const highlightSection = (e, value) => {
    if (creatingActivity) return;
    if (highlightedSection.includes(value.split('.')[1])) {
      setHighlightedSection([]);
      setActivities(book.activities);
    } else {
      setHighlightedSection((old) => [...old, value.split('.')[1]]);
      setActivities(
        book.activities.filter(
          (e) => e?.sections?.includes(value.split('.')[1]) && e.paragraphs.length === 0
        )
      );
      // setScrollToId(value);
    }
  };

  const setCalendarShow = (bool) => {
    setShowCalendar(bool);
  };

  const scrollWithSpectrum = (top) => {
    const centreFoldEl = scrollerRef.current;
    centreFoldEl.scrollTop = (top / 100) * (centreFoldEl.scrollHeight - centreFoldEl.clientHeight);
    // const { scrollTop } = centreFoldEl;
    // scrollerRef.current.scrollTop = top;
  };

  const dynamicPStyles = (chap, section, paragraph) => {
    let className = 'theme_para_se paragraph_element main_p';

    className +=
      book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 ? ' rich' : '';
    className += settings.fontLarge ? ' fontLarge' : '';
    className += highlightedIndexes.includes(`${chap._id}.${section._id}.${paragraph._id}`)
      ? ' activated_p_tags'
      : '';
    className += highlightedParagraph === paragraph._id ? ' bg_grey' : '';

    return className;
  };

  const dynamicSectionStyles = (chap, section) => {
    let className = 'p-1 section_element';
    className += settings.fontLarge ? ' fontLarge' : '';
    className += highlightedSection.includes(section._id) ? ' highlighted' : '';
    className +=
      draggedOver &&
      draggedOver.type === 'section' &&
      // eslint-disable-next-line eqeqeq
      draggedOver.index == `${chap._id}.${section._id}`
        ? ' trigger'
        : '';

    return className;
  };

  const scrollTo = (activity) => {
    if (activity === null) {
      setHighlightedParagraph(null);
      setHighlightedChapter(null);
      setHighlightedSection([]);
      setActivities(book.activities);
    } else {
      if (
        (!activity.sections || activity?.sections?.length === 0) &&
        activity.paragraphs?.length === 0
      ) {
        setHighlightedChapter(activity.chapter._id);
        setScrollToId(activity.chapter._id);
      } else if (activity?.sections?.length > 0 && activity.paragraphs.length === 0) {
        setScrollToId(activity.chapter._id + '.' + activity.sections[0]);
        setHighlightedSection(activity.sections);
      } else {
        setHighlightedParagraph(activity.paragraphs[0]);
        setScrollToId(
          activity.chapter._id + '.' + activity.section + '.' + activity.paragraphs[0]
        );
      }
    }
  };

  return (
    <div>
      <section className='class_room_wrap teach mt-0' style={{ overflow: 'hidden' }}>
        <div>
          <div
            className={`flex-container`}
            onMouseMove={(event) => {
              event.preventDefault();
              if (isDraggingActivity) {
                setDraggedActivityPosition({
                  top: (event.clientY / window.innerHeight) * 100,
                  left: (event.clientX / window.innerWidth) * 100,
                });
              }
              if (!dragging) return;
              const left = (event.clientX / window.innerWidth) * 100; // percentage of viewport width
              const top = (event.clientY / window.innerHeight) * 100; // percentage of viewport height
              setMousePosition({ x: left, y: top });
              if (isScrolling) {
                const { clientY: y } = event;
                const { scrollTop } = scrollerRef.current;
                scrollerRef.current.scrollTop = scrollTop + y;
              }
            }}
            onMouseUp={(e) => {
              if (isResizing) setIsResizing(false);
              if (isScrolling) setIsScrolling(false);
              if (isDraggingActivity) {
                setIsDraggingActivity(false);
              }
              e.stopPropagation();
            }}
          >
            <div className='activity-spectrum'>
              <div>
                <StudentDraggableSidebar
                  scrollPara={scrollToParagraph}
                  scrollBook={scrollToSection}
                  setParentIsScrolling={setIsScrolling}
                  scrollCentre={scrollWithSpectrum}
                  isScrolling={isScrolling}
                />
              </div>
            </div>
            <div className='side-nav' style={{ overflow: 'unset' }}>
              <StudentSidebar
                draggedOver={draggedOver}
                anchorBook={scrollToParagraph}
                scrollChapter={scrollToChapter}
                scrollSection={scrollToSection}
                handleCalnendarShow={setCalendarShow}
              />
            </div>
            <div className='centre-fold'>
              <div
                className={`row ${reverse ? 'reverse' : ''}`}
                style={{
                  '--bs-gutter-x': '0',
                  '--bs-gutter-y': '0',
                  justifyContent: 'space-between',
                }}
              >
                {/* {Header()} */}
                <StudentHeader canLeave={true} />
                <div
                  className='col-xl-7 col-lg-12'
                  style={{ width: '63.333333%', padding: '0px 25px' }}
                >
                  <StudentInnerHeader
                    highlightedSection={highlightedSection}
                    writingActivity={writingActivity}
                    creatingActivity={creatingActivity}
                  />
                  <div
                    // className="center_content"
                    className='center_content_student_learn'
                    ref={scrollableContent}
                  >
                    <Fragment>
                      {book.chapters?.map((chap, chapInd) => (
                        <div
                          className={`${
                            highlightedChapter === chap._id && 'highlighted'
                          } book chapter_element`}
                          style={{ padding: '20px 10px 20px 27px' }}
                          data-id={chapInd}
                          key={chapInd}
                          id={chap?._id}
                        >
                          {loaders?.bookLoader ? (
                            <div className='chap-load'>
                              <div
                                className='content-skeleton mb-0 inner-head-load'
                                style={{
                                  height: '58px',
                                  width: '64%',
                                  borderRadius: '4px',
                                }}
                              ></div>
                              <div
                                className='content-skeleton mb-0 inner-head-load'
                                style={{
                                  height: '29px',
                                  width: '94%',
                                  borderRadius: '4px',
                                }}
                              ></div>
                            </div>
                          ) : !loaders?.bookLoader ? (
                            <>
                              {book.activities.find(
                                (e) =>
                                  e?.chapter._id === chap?._id &&
                                  e.paragraphs.length === 0 &&
                                  (!Array.isArray(e.sections) || e?.sections?.length === 0)
                              ) ? (
                                <img
                                  src={dimond}
                                  alt='diamond'
                                  className='cursor'
                                  onClick={(e) => {
                                    setHighlightedParagraph(null);
                                    highlightChapter(e, chap._id);
                                  }}
                                  style={{
                                    position: 'relative',
                                    float: 'right',
                                  }}
                                />
                              ) : (
                                ''
                              )}
                              <h4
                                className={`sub_heading max_550 chapter_element ${
                                  draggedOver &&
                                  draggedOver.type === 'chapter' &&
                                  draggedOver.index === chap._id
                                    ? 'trigger'
                                    : ''
                                }`}
                                data-id={chap?._id}
                              >
                                <HtmlAsText htmlContent={chap?.title} />
                              </h4>
                              <p
                                className={
                                  settings.fontLarge
                                    ? 'theme_para_se chapter_element fontLarge'
                                    : 'theme_para_se chapter_element'
                                }
                                data-id={chap?._id}
                              >
                                <HtmlAsText htmlContent={chap?.description} />
                              </p>
                              {<hr className='activity-line' />}
                            </>
                          ) : (
                            ''
                          )}

                          {chap?.sections?.map((section, secIndex) => (
                            <div
                              key={secIndex}
                              id={`${chap?._id}.${section?._id}`}
                              data-id={`${chap?._id}.${section?._id}`}
                              className={dynamicSectionStyles(chap, section)}
                              style={{ position: 'relative' }}
                            >
                              {loaders?.bookLoader ? (
                                <>
                                  <div className='' style={{ marginTop: '32px' }}>
                                    <div
                                      className='content-skeleton  inner-head-load'
                                      style={{
                                        height: '38px',
                                        width: '38%',
                                        borderRadius: '4px',
                                        marginBottom: '4px',
                                      }}
                                    ></div>
                                    <div
                                      className='content-skeleton  inner-head-load'
                                      style={{
                                        height: '116px',
                                        width: '94%',
                                        borderRadius: '4px',
                                        marginBottom: '32px',
                                      }}
                                    ></div>
                                    <div
                                      className='content-skeleton  inner-head-load'
                                      style={{
                                        height: '319px',
                                        width: '94%',
                                        borderRadius: '4px',
                                        marginBottom: '20px',
                                      }}
                                    ></div>
                                    <div
                                      className='content-skeleton  inner-head-load'
                                      style={{
                                        height: '290px',
                                        width: '94%',
                                        borderRadius: '4px',
                                      }}
                                    ></div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {book.activities.findIndex(
                                    (e) =>
                                      e.sections?.some((sec) =>
                                        typeof sec === 'object'
                                          ? sec._id === section._id
                                          : sec === section._id
                                      ) &&
                                      (e.sections?.length === 1 ||
                                        e.sections?.findIndex(
                                          (sec) =>
                                            (typeof sec === 'object' ? sec._id : sec) ===
                                            section._id
                                        ) === 0)
                                  ) > -1 ? (
                                    <img
                                      src={dimond}
                                      alt='diamond'
                                      className='cursor'
                                      onClick={(e) => {
                                        setHighlightedParagraph(null);
                                        highlightSection(e, `${chap?._id}.${section?._id}`);
                                      }}
                                      style={{
                                        // position: "absolute",
                                        // top: -12,
                                        // right: 4,
                                        position: 'relative',
                                        float: 'right',
                                      }}
                                    />
                                  ) : null}
                                  <h5
                                    className={` mb-0 ${
                                      book?.activities?.findIndex(
                                        (e) => e?.section === section?._id
                                      ) > -1
                                        ? 'rich'
                                        : ''
                                    }`}
                                  >
                                    <HtmlAsText htmlContent={section?.title} />
                                  </h5>
                                  {section.paragraphs.map((paragraph, index) => (
                                    <>
                                      {(paragraph?.text ||
                                        (paragraph?.type === 'paragraph' &&
                                          paragraph?.media.length > 0)) && (
                                        <div
                                          key={paragraph._id}
                                          className={`${
                                            highlightedParagraph === paragraph._id
                                              ? ' bg_grey'
                                              : ''
                                          }${
                                            draggedOver &&
                                            draggedOver.type === 'paragraph' &&
                                            draggedOver.index ===
                                              `${chap?._id}.${section?._id}.${paragraph?._id}`
                                              ? 'trigger'
                                              : ''
                                          } main-pera-wraper unique_paragraph ${
                                            isResizing ? 'resizing' : 'cursor'
                                          } `}
                                          data-id={paragraph?._id}
                                          data-secid={section?._id}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setCalendarShow(false);
                                          }}
                                        >
                                          {paragraph.title && (
                                            <h4
                                              className='mini_heading paragraph_element'
                                              data-id={paragraph?._id}
                                            >
                                              <HtmlAsText htmlContent={paragraph?.title} />
                                            </h4>
                                          )}
                                          <div
                                            className={dynamicPStyles(chap, section, paragraph)}
                                            data-id={`${chap._id}.${section._id}.${paragraph._id}`}
                                            id={`${chap._id}.${section._id}.${paragraph._id}`}
                                            style={{ position: 'relative' }}
                                          >
                                            {book.activities.findIndex(
                                              (e) =>
                                                e.paragraphs.includes(paragraph._id) &&
                                                (e.paragraphs.length === 1 ||
                                                  [...e.paragraphs]
                                                    .sort((a, b) => a - b)
                                                    .indexOf(paragraph._id) === 0)
                                            ) > -1 && (
                                              <img
                                                src={dimond}
                                                alt='diamond'
                                                className='cursor'
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setHighlightedSection([]);
                                                  if (highlightedParagraph === paragraph._id) {
                                                    setHighlightedParagraph(null);
                                                    setActivities(book.activities);
                                                  } else {
                                                    setHighlightedParagraph(paragraph._id);
                                                    setActivities(
                                                      book.activities.filter((e) =>
                                                        e.paragraphs.includes(paragraph._id)
                                                      )
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  position: 'absolute',
                                                  top: 0,
                                                  right: -8,
                                                }}
                                              />
                                            )}

                                            {paragraph.text && (
                                              <HtmlAsText htmlContent={paragraph.text} />
                                            )}

                                            {paragraph.video && paragraph.video.link && (
                                              <div>
                                                <video
                                                  src={paragraph.video.link}
                                                  controls
                                                  width='100%'
                                                />
                                                <span>{paragraph.video.description}</span>
                                              </div>
                                            )}

                                            {paragraph.media && (
                                              <Fragment>
                                                {paragraph.media.map((media, mIndex) => (
                                                  <MediaComponent
                                                    chapterIndex={chapInd}
                                                    secInd={secIndex}
                                                    pIndex={index}
                                                    setBook={setBooks}
                                                    book={books}
                                                    media={media}
                                                    index={mIndex}
                                                    parent={'paragraph'}
                                                    parentId={paragraph._id}
                                                  />
                                                ))}
                                              </Fragment>
                                            )}
                                            {paragraph.image && paragraph.image.link && (
                                              <div>
                                                <img src={paragraph.image.link} alt='image-link' />
                                                <span>{paragraph.image.description}</span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  ))}
                                </>
                              )}
                            </div>
                          ))}
                          <div
                            className='chapter_element'
                            data-id={chap?._id}
                            style={{ width: '100%', height: '1px' }}
                          ></div>
                        </div>
                      ))}
                    </Fragment>
                  </div>
                </div>
                <StudentRightSidebar
                  scrollToParagraph={scrollToParagraph}
                  highlightedParagraph={highlightedParagraph}
                  spreadActivitiesSetter={spreadActivitiesSetter}
                  scroll={scrollToSection}
                  activities={activities}
                  scrollTo={scrollTo}
                  showClear={
                    highlightedChapter || highlightedSection.length > 0 || highlightedParagraph
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          handleCalnendarShow={setCalendarShow}
          isDraggingActivity={isDraggingActivity}
          draggedActivity={draggedActivity}
          setDraggedActivityPosition={setDraggedActivityPosition}
          setIsDraggingActivity={setIsDraggingActivity}
          showCalendar={showCalendar}
          setShowCalendar={setShowCalendar}
        />
      </section>
      {<DeleteModal />}
      <ActivitySetModal
        show={activitySetModal.show}
        options={activitySetModal}
        setActivitySetModal={setActivitySetModal}
      />
    </div>
  );
};

export default StudentBook;
